module.exports = __webpack_public_path__ + "static/media/productos.76f6dac3.png";